import { PUB_SUB_EVENT, PUBSUB_GROUP_EVENT } from '@common'

// Base strategy interface
class EventStrategy {
    handle(payload, dispatch, notifyListeners) {
        throw new Error('handle method must be implemented')
    }
}

// Specific event strategies - keeping original logic exactly
class OrderPaymentStatusStrategy extends EventStrategy {
    handle(payload, dispatch, notifyListeners) {
        // Original _handleOrderPaid logic
        if (dispatch) {
            dispatch({ type: 'order/updateOrderPaid', payload })
        }

        notifyListeners(PUB_SUB_EVENT.ORDER_PAYMENT_STATUS_UPDATE, payload)
    }
}

class OrderCompletedStrategy extends EventStrategy {
    handle(payload, dispatch, notifyListeners) {
        // Original _handleOrderCompleted logic
        if (dispatch) {
            dispatch({ type: 'order/updateOrderCompleted', payload })
        }

        notifyListeners(PUB_SUB_EVENT.COMPLETED_ORDER, payload)
    }
}

class CompletedDishStrategy extends EventStrategy {
    handle(payload, dispatch, notifyListeners) {
        // Original _handleCompletedDish logic
        if (dispatch) {
            dispatch({ type: 'order/updateCompletedDish', payload })
        }

        notifyListeners(PUB_SUB_EVENT.COMPLETED_DISH, payload)
    }
}

class InventoryStatusStrategy extends EventStrategy {
    handle(payload, dispatch, notifyListeners) {
        // Original _handleInventoryStatusUpdate logic
        if (dispatch) {
            dispatch({ type: 'dashboard/updateInventoryStatus', payload })
        }

        notifyListeners(PUB_SUB_EVENT.INVENTORY_STATUS_UPDATE, payload)
    }
}

class CartSnapshotStrategy extends EventStrategy {
    handle(payload, dispatch, notifyListeners) {
        // Original _handleCartSnapshot logic
        const cart = payload?.cart
        if (!cart) {
            console.warn('No cart data in snapshot payload')
            return
        }

        if (dispatch) {
            dispatch({ type: 'cart/applyCartSnapshot', payload })
        }
        notifyListeners(PUBSUB_GROUP_EVENT.CART_SNAPSHOT, payload)
    }
}

class PaymentEventStrategy extends EventStrategy {
    handle(payload, dispatch, notifyListeners) {
        // Just forward payment events to listeners (original behavior)
        notifyListeners(this.eventType, payload)
    }

    constructor(eventType) {
        super()
        this.eventType = eventType
    }
}

// Strategy registry
export const EVENT_STRATEGIES = {
    [PUB_SUB_EVENT.ORDER_PAYMENT_STATUS_UPDATE]: new OrderPaymentStatusStrategy(),
    [PUB_SUB_EVENT.COMPLETED_ORDER]: new OrderCompletedStrategy(),
    [PUB_SUB_EVENT.COMPLETED_DISH]: new CompletedDishStrategy(),
    [PUB_SUB_EVENT.INVENTORY_STATUS_UPDATE]: new InventoryStatusStrategy(),

    [PUBSUB_GROUP_EVENT.CART_SNAPSHOT]: new CartSnapshotStrategy(),
    [PUBSUB_GROUP_EVENT.PAYMENT_LATER]: new PaymentEventStrategy(PUBSUB_GROUP_EVENT.PAYMENT_LATER),
    [PUBSUB_GROUP_EVENT.PAYMENT_REQUEST]: new PaymentEventStrategy(PUBSUB_GROUP_EVENT.PAYMENT_REQUEST),
    [PUBSUB_GROUP_EVENT.PAYMENT_SUCCESS]: new PaymentEventStrategy(PUBSUB_GROUP_EVENT.PAYMENT_SUCCESS),
    [PUBSUB_GROUP_EVENT.PAYMENT_FAILED]: new PaymentEventStrategy(PUBSUB_GROUP_EVENT.PAYMENT_FAILED),
    [PUBSUB_GROUP_EVENT.PAYMENT_CANCEL]: new PaymentEventStrategy(PUBSUB_GROUP_EVENT.PAYMENT_CANCEL),
}

// Factory for adding new strategies
export const addEventStrategy = (eventType, strategy) => {
    EVENT_STRATEGIES[eventType] = strategy
}
